module.exports = __webpack_public_path__ + "media/images/icons/integration-af83312f9e0611321572ff476011b601.png";